import Reflux from "reflux";

export var LanguageActions = Reflux.createActions([
    "set"
]);